import { formatCellValue } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import type { PrivateHireData, PrivateHireMovementData } from "@/lib/coach-manager/types";

function serialNoOf(row: PrivateHireData | PrivateHireMovementData): number {
  return "PrivateHireMovementDataTitleSerialNo" in row
    ? row.PrivateHireMovementDataTitleSerialNo
    : row.PrivateHireDataTitleSerialNo;
}

/**
 * Shared table for `PrivateHireData`/`PrivateHireMovementData` rows — same
 * `{ TextValue, NumberValue, MoneyValue, DateValue, YesNoValue }` shape as
 * Contract's data rows, mirroring `DataValuesTable` (kept as its own file
 * rather than reused directly since the two entities' row types don't
 * structurally overlap at the type level, even though the rendering is
 * identical).
 */
export function PrivateHireDataValuesTable({
  rows,
}: {
  rows: (PrivateHireData | PrivateHireMovementData)[];
}) {
  if (rows.length === 0) return null;

  return (
    <DataTable
      headers={[
        { label: "Title #" },
        { label: "Text" },
        { label: "Number" },
        { label: "Money" },
        { label: "Date" },
        { label: "Yes/No" },
      ]}
    >
      {rows.map((row) => (
        <tr key={serialNoOf(row)} className="border-b last:border-b-0">
          <td className="px-4 py-2">{serialNoOf(row)}</td>
          <td className="px-4 py-2">{formatCellValue(row.TextValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.NumberValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.MoneyValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.DateValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.YesNoValue)}</td>
        </tr>
      ))}
    </DataTable>
  );
}
